import React, { Fragment, useState, useCallback, useEffect, useRef } from 'react';
import { Button } from 'antd';
import Link from 'next/link';
import styles from './index.less';
import FrozenRatio from '../../components/FrozenRatio/FrozenRatio';
import { PlayerInModal } from '../../components/YoutubePlayer';
import { FormattedMessage, useIntl } from 'react-intl';
import GoogleTagManager from '../../third_party/GoogleTagManager';
import AutoPlayer from '../../components/AutoPlayer';

const YOUTUBE_IFRAME = 'https://www.youtube.com/iframe_api';
const scriptId = 'youtube-script-cover';

async function loadYoutubePlayerPlugin(id) {
  const scriptTag = document.getElementById(scriptId);

  if (scriptTag) {
    Promise.resolve();
    return;
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.onload = function () {
      typeof resolve === 'function' && resolve();
    };
    script.onerror = reject;
    script.src = YOUTUBE_IFRAME;
    script.id = id;
    document.body.append(script);
  });
}

function initialYoutube(playerId, videoId, callback) {
  let player = new window.YT.Player(playerId, {
    videoId,
    width: '100%',
    height: '100%',
    playerVars: {
      autoplay: 1,
      controls: 0,
      loop: 1,
      disablekb: 1,
      muted: 1,
      playsinline: 0,
      'webkit-playsinline': 1,
      rel: 0,
      enablejsapi: 1,
      cc_load_policy: 0,
      // playlist: videoId,
      modestbranding: 1,
      iv_load_policy: 3,
    },
    events: {
      onReady: (e) => {
        e.target.mute();
        e.target.playVideo();
        callback({ playing: true });
      },
      onStateChange: (e) => {
        if (window.YT && e.data === window.YT.PlayerState.ENDED) {
          player.playVideo();
          callback({ playing: true });
        }
      },
    },
  });

  return player;
}

const DescriptionCardV2 = ({
  title,
  description,
  poster,
  posterAlt,
  action,
  showAction = true,
  posterRatio = 1,
  direction = 'normal',
  youtubeVideoId = '',
  autoPlayOnCover = false,
  children,
}) => {
  const ref = useRef();
  const videoPlayerRef = useRef(null);
  const [playerModalVisible, setPlayerModalVisible] = useState(false);
  const [videoPlayingOnCover, setVideoPlayingOnCover] = useState(true);
  const onPlayChowbusOne = useCallback(() => {
    GoogleTagManager.trackPlayVideo();
    setPlayerModalVisible(true);
  }, []);
  const handleCloseModal = () => {
    setPlayerModalVisible(false);
  };

  return (
    <div className={styles.DescriptionCard}>
      <div className="description-info">
        <h1 className="bold description-title">{title}</h1>
        {description && <p className="description-content">{description}</p>}
        {children && children}
        <div className="actions">
          {showAction &&
            (action || (
              <Fragment>
                <Link href="/get-a-demo">
                  <a>
                    <Button type="primary" className="action-button" style={{ paddingTop: 0, paddingBottom: 0 }}>
                      <FormattedMessage id="home.get-demo.bitton" />
                    </Button>
                  </a>
                </Link>
                {youtubeVideoId && (
                  <Button className="action-button-outline" onClick={onPlayChowbusOne}>
                    <FormattedMessage id="home.pay-video.bitton" />
                  </Button>
                )}
              </Fragment>
            ))}
        </div>
      </div>
      <div className={`description-card-poster`}>
        {(!autoPlayOnCover || !youtubeVideoId) && (
          <div className="poster-img-container " id="chowbus_one_player_cover" ref={ref}>
            <FrozenRatio ratio={posterRatio}>
              <img width="100%" src={poster} alt={posterAlt} />
            </FrozenRatio>
          </div>
        )}
        {youtubeVideoId && autoPlayOnCover && (
          <AutoPlayer
            poster={`${poster}`}
            posterAlt={posterAlt}
            posterRatio={posterRatio}
            youtubeVideoId={youtubeVideoId}
            autoPlayOnCover={true}
            canPause={true}
          />
        )}
      </div>
      {playerModalVisible && (
        <PlayerInModal onClose={handleCloseModal} playerId={'chowbus_one_player'} videoId={youtubeVideoId} />
      )}
    </div>
  );
};

export default DescriptionCardV2;
